import { z } from "zod";

const COUPON_CODE_MAX_LENGTH = 64;

export const couponCodeSchema = z
  .string()
  .trim()
  .min(1)
  .max(COUPON_CODE_MAX_LENGTH)
  .transform((code) => code.toUpperCase());

export const couponPreviewQuerySchema = z.object({
  productSlug: z.string().min(1).max(200),
});

export const couponParamSchema = z.object({ code: couponCodeSchema });

export const createCheckoutSchema = z.object({
  productSlug: z.string().min(1).max(200),
  couponCode: couponCodeSchema.optional(),
});
export type CreateCheckoutInput = z.infer<typeof createCheckoutSchema>;

export const uuidParamSchema = z.object({ id: z.uuid() });
export const invoiceParamSchema = uuidParamSchema;
